"use client";
import Spinner from "./components/Spinner";
import styles from '../styles/Home.module.css';

export default function Loading() {
  return <main className={styles.main} data-lk-theme="default">
            <Spinner/>
        </main>;
}
